import type { DeepWiden } from './types';
import { de } from './de';
import { en } from './en';

/**
 * Canonical message shape — every locale must satisfy this structurally.
 * Derived from the German dictionary's structure (with string-literal types
 * widened to plain `string`) so other locales can supply different strings
 * for the same keys; differently-shaped objects still fail `tsc`.
 */
export type Messages = DeepWiden<typeof de>;

/**
 * Raw locale registry — the single source of truth for which locales exist.
 *
 * Kept in its own dependency-light module (it imports only the locale sources
 * and a type, never `@immo/api-contract`) so the i18n CI scripts
 * (`check:i18n-parity`, …) can import the live locale set without dragging in
 * the package index's heavier dependencies. Add a new locale here and every
 * consumer — the package index, the runtime, and the parity gate — picks it up.
 */
export const dictionaries: { 'de-DE': Messages; 'en-US': Messages } = { 'de-DE': de, 'en-US': en };

export type Locale = keyof typeof dictionaries;
